/**
 * Derives the current page's language from its URL path prefix — the same
 * convention your Gatsby language switcher already uses (e.g. /fr/... for
 * French, no prefix for the default language). Supports exactly two
 * languages by design.
 *
 * Deliberately synchronous and not DOM-dependent (unlike reading
 * <html lang>, which can be written asynchronously by libraries like
 * react-helmet): pathname is available immediately in both
 * gatsby-ssr.js and gatsby-browser.js via wrapPageElement's `props.location`,
 * so this needs no effect/observer and can't produce a hydration mismatch.
 *
 * @param {string} pathname e.g. "/fr/alpo" or "/alpo"
 * @param {string} defaultLanguage e.g. "en" — no path prefix
 * @param {string} secondaryLanguage e.g. "fr" — prefixed as /fr/...
 * @returns {string} defaultLanguage or secondaryLanguage
 */
export default function resolvePageLanguage(
    pathname,
    defaultLanguage,
    secondaryLanguage
) {
    if (!pathname || !secondaryLanguage) return defaultLanguage;

    const prefix = `/${secondaryLanguage}`;
    const isSecondary = pathname === prefix || pathname.startsWith(`${prefix}/`);

    return isSecondary ? secondaryLanguage : defaultLanguage;
}